"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNameArchive = void 0;
const domain_1 = require("./domain");
exports.defaultNameArchive = {
    [domain_1.Race.Human]: {
        first: {
            [domain_1.Gender.Male]: [
                'William',
                'John',
                'Richard',
                'Robert',
                'Henry',
                'Ralph',
                'Thomas',
                'Walter',
                'Elmar',
                'Roger',
                'Fawkes',
                'Hugh',
                'Godwin',
                'Leofric',
                'Robert',
                'Gerold',
                'Alaric',
                'Dagaric',
                'Burchard',
                'Lothar',
                'Theodoric',
                'Wulfhelm',
                'Bernard',
                'Guntram',
                'Clovis',
                'Crispin',
                'Conrad',
                'Eustace',
                'Justus',
                'Lucan',
                'Oliver',
                'Pascal',
                'Randolf',
                'Gregory',
                'Judd',
                'Radax',
                'Zemislav',
                'Rolf',
                'Walter',
                'Ernald',
                'Blacwin',
                'Gilbert',
                'Anselm',
                'Aubrey',
                'Adam',
                'Saer',
                'Thurstan',
                'Warin',
                'Ymbert',
            ],
            [domain_1.Gender.Female]: [
                'Alice',
                'Matilda',
                'Agnes',
                'Margaret',
                'Isabella',
                'Emma',
                'Beatrice',
                'Mabel',
                'Cecilia',
                'Ada',
                'Amiria',
                'Anabel',
                'Avelina',
                'Clarice',
                'Constance',
                'Edith',
                'Emma',
                'Estrilda',
                'Eva',
                'Grecia',
                'Hilda',
                'Isolde',
                'Linota',
                'Marsila',
                'Maud',
                'Muriel',
                'Nesta',
                'Sybil',
            ],
        },
        last: [
            'Birdwhistle',
            'Berrycloth',
            'Culpepper',
            'Tumbler',
            'Gastrell',
            'Bread',
            'Pussett',
            'Hatman',
            'Temples',
            'Raynott',
            'Woodbead',
            'Harred',
            'Rummage',
            'Ashworth',
            'Butterworth',
            'Crowther',
            'Greenwood',
            'Ingham',
            'Fletcher',
            'Cheesman',
            'Tapper',
            'Slater',
            'Mason',
            'Arkwright',
            'Stoddard',
            'Clark',
            'Dempster',
            'Franklin',
            'Dyer',
            'Weaver',
            'Parson',
            'Maidman',
            'Spinner',
            'Steele',
            'Toller',
            'Taylor',
            'Ward',
            'Hardy',
            'Keen',
            'Aimar',
            'Bigge',
            'Blythe',
            'Curtis',
            'Bonner',
            'Hendman',
            'Mundy',
            'Moody',
            'Rey',
            'Sharp',
            'Stern',
            'Swann',
            'Tait',
            'Truman',
            'Black',
            'Red',
            'Whitehead',
        ],
    },
    [domain_1.Race.Dwarf]: {
        first: {
            [domain_1.Gender.Male]: [
                'Baird',
                'Paden',
                'Connach',
                'Morven',
                'Beathan',
                'Dougal',
                'Tam',
                'Murdoe',
                'Rab',
                'Akir',
                'Alpin',
                'Amhuinn',
                'Athol',
                'Bac',
                'Baen',
                'Balgaire',
                'Bhreac',
                'Brochan',
                'Brodee',
                'Broehain',
                'Caladh',
                'Dearg',
                'Diarmad',
                'Domhnall',
                'Donnachadh',
                'Dubhghall',
                'Eanraig',
                'Fearchar',
                'Frangag',
                'Goraidh',
                'Gowan',
                'Harailt',
                'Iver',
                'Kade',
                'Keeley',
            ],
            [domain_1.Gender.Female]: [
                'Marcail',
                'Senga',
                'Sorcha',
                'Ailsa',
                'Liùsaidh',
                'Morag',
                'Cadha',
                'Caitir',
                'Beileag',
                'Curstaidh',
                'Gormlaith',
                'Fionola',
                'Jeanie',
                'Leagsaidh',
                'Maidie',
                'Malmuira',
                'Nathiara',
                'Robena',
                'Stineag',
                'Teasag',
                'Wynda',
            ],
        },
        last: [
            'Granitehold',
            'Oakhelm',
            'Rowanshield',
            'Redtorc',
            'Hillpipe',
            'Sheeraxe',
            'Slatestop',
            'Irontree',
            'Furnacestoker',
            'Gemhand',
            'Runebar',
            'Silverseam',
            'Squareshield',
            'Truehammer',
            'Hardsmelter',
            'Deepcave',
            'Lonecavern',
            'Coldforge',
            'Bronzehook',
            'Tinhammer',
            'Stonebearer',
            'Coinstamper',
            'Hardcrevice',
            'Hardfall',
            'Seamfinder',
            'Grimgauntlet',
        ],
    },
    [domain_1.Race.Elf]: {
        first: {
            [domain_1.Gender.Male]: [
                'Anaeirin',
                'Elian',
                'Glyn',
                'Hywel',
                'Idris',
                'Llewelyn',
                'Maelon',
                'Peredur',
                'Aed',
                'Ailill',
                'Aodhan',
                'Arawn',
                'Bedivere',
                'Belenos',
                'Beli',
                'Cernunnos',
                'Conlaoch',
                'Connla',
                'Daire',
                'Diarmait',
                'Eber',
                'Fachtna',
                'Fedelmid',
                'Fiachra',
                'Geraint',
                'Goronwy',
                'Govannon',
                'Gwydion',
                'Lugaid',
                'Lugos',
                'Medraut',
                'Medrod',
                'Myrddin',
                'Naoise',
                'Nechtan',
                'Nuada',
                'Nudd',
                'Oengus',
                'Oisin',
                'Parthalan',
                'Pwyll',
                'Taranis',
                'Uthyr',
            ],
            [domain_1.Gender.Female]: [
                'Anwen',
                'Bronwen',
                'Eluned',
                'Gwenfrewi',
                'Kerwyn',
                'Maelona',
                'Morwen',
                'Agrona',
                'Aoife',
                'Aranrhod',
                'Bebinn',
                'Doireann',
                'Doirend',
                'Eigyr',
                'Eimhear',
                'Emer',
                'Epona',
                'Etain',
                'Fedelm',
                'Feidelm',
                'Feidlimid',
                'Finnuala',
                'Grainne',
                'Lunete',
                'Maeve',
                'Meadhbh',
                'Mor Rioghan',
                'Muirenn',
                'Neas',
                'Niamh',
                'Rhiannon',
                'Sabia',
                'Sadb',
                'Sionann',
            ],
        },
        last: [
            'Dwyfed',
            'Gwaltleuad',
            'Serentred',
            'Cangoed',
            'Nantarian',
            'Prentyl',
            'Awelyde',
            'Golanbell',
            'Coryswar',
            'Distawyn',
            'Gaefrap',
            'Rhewynnar',
            'Borebaith',
            'Ilafnwir',
            'Saethgalon',
            'Wedili',
            'Diwedion',
        ],
    },
    [domain_1.Race.Halfling]: {
        first: {
            [domain_1.Gender.Male]: [
                'Wilber',
                'Eadwulf',
                'Sideman',
                'Merewith',
                'Remigius',
                'Bertwald',
                'Hugh',
                'William',
                'Sam',
                'Walter',
                'Britwine',
                'Osbern',
                'Edmund',
                'Herbert',
                'Ordbriht',
                'Maurice',
                'Godwine',
                'Herman',
                'Arnost',
                'Siward',
                'Peter',
                'Duduc',
                'Elphege',
                'Ralph',
                'Heca',
                'Rodulf',
                'Grimketel',
                'Bloet',
                'Stiggy',
                'Cynesige',
                'Lyfing',
                'Ealdred',
                'Thomas',
                'Cerdic',
                'Deorwine',
                'Dudda',
                'Dunstan',
                'Eadgar',
                'Eadwig',
                'Eadweard',
                'Godgifu',
                'Heard',
                'Hereward',
                'Leafstan',
                'Leofwine',
                'Osgar',
                'Tata',
                'Wigmund',
                'Wigstan',
                'Wulfric',
            ],
            [domain_1.Gender.Female]: [
                'Peggy',
                'Tabbatha',
                'Godiva',
                'Hild',
                'Hilda',
                'Cyneburg',
                'Mildred',
                'Sunniva',
                'Wassa',
                'Wulfrun',
                'Elfreda',
                'Edith',
                'Astride',
                'Dagmar',
                'Edda',
                'Frida',
                'Grimhildr',
                'Gulla',
                'Gunhild',
                'Helga',
                'Inga',
                'Katla',
                'Magnhild',
                'Ragna',
                'Pora',
                'Unna',
                'Valdis',
                'Vigdis',
            ],
        },
        last: [
            'Goodman',
            'Lightfoot',
            'Abercorn',
            'Addis',
            'Alford',
            'Apley',
            'Arscott',
            'Bagnal',
            'Bampfield',
            'Batten',
            'Bawden',
            'Belfield',
            'Bevil',
            'Bicton',
            'Birdwood',
            'Blount',
            'Bosum',
            'Bourman',
            'Twofields',
            'Calmady',
            'Carew',
            'Cavel',
            'Clapp',
            'Mousehill',
            'Coode',
            'Coppice',
            'Crocker',
            'Crossman',
            'Dockwra',
            'Digon',
            'Dodscombe',
            'Doman',
            'Doway',
            'Dynsell',
            'Edye',
            'Erisey',
            'Estcott',
            'Eveleigh',
            'Fowler',
            'Fulform',
            'Giffard',
            'Redfinch',
            'Grenville',
            'Grigg',
            'Hakewill',
            'Halep',
            'Halse',
            'Hamely',
            'Hawker',
            'Hewis',
            'Overhill',
            'Hodge',
            'Hone',
            'Honywood',
            'Hooton',
            'Hurst',
            'Jago',
            'Joliffe',
            'Jolle',
            'Kekewich',
            'Kelloway',
            'Branthorne',
            'Kendall',
            'Kitson',
            'Killowe',
            'Knapman',
            'Lampen',
            'Levelis',
            'Lethbridge',
            'Lopes',
            'Lucombe',
            'Marwood',
            'Mayow',
            'Mohun',
            'Nanfan',
            'Nanspyan',
            'Nuttal',
            'Pipard',
            'Pokeswill',
            'Priestwood',
            'Rashcliff',
            'Rennel',
            'Riggs',
            'Rolle',
            'Sainthill',
            'Scobell',
            'Seymour',
            'Sharpleigh',
            'Sloggett',
            'Skiberyo',
            'Sole',
            'Southcotte',
            'Specott',
            'Stribblehill',
            'Strowbridge',
            'Tolcher',
            'Trebarefoot',
            'Treffry',
            'Trefusis',
            'Tremayle',
            'Tremayne',
            'Trevanion',
            'Trible',
            'Tuckmoor',
            'Tubb',
            'Tynte',
            'Tyrell',
            'Upstick',
            'Vosper',
            'Waddon',
            'Wader',
            'Westcombe',
            'Woolcombe',
            'Wykes',
            'Yarde',
        ],
    },
};
//# sourceMappingURL=defaultNameArchive.js.map